// extracted by mini-css-extract-plugin
module.exports = {"sidebarLogo":"sidebarLogo--1Ni3x"};